import bFormSelect from 'bootstrap-vue/es/components/form-select/form-select';

var pyFormSelect = {
  name: 'pyFormSelect',
  extends: bFormSelect,
  methods:{
    focus: function(e){
      this.$parent.$emit('pyInputFocus', e.target);
    },
    blur: function(e){
      this.$parent.$emit('pyInputBlur', e.target);
    },
    change: function(e){
      this.$parent.$emit('pyInputChange', e.target);
    }
  },
  mounted: function(){
    this.$el.addEventListener("focus", this.focus)
    this.$el.addEventListener("blur", this.blur)
    this.$el.addEventListener("change", this.change)
    //lets form group know its a multiple select
    this.$parent.$emit('pyAddClassToParent', (this.$el.multiple) ? "multiple" : "single")
  }
};

export default pyFormSelect;


